import account from "../services/account";
import moment from 'moment';

function validaAccount(val, args) {

  let type = args[0];
  let url = undefined;
  let obj = {};

  if (!val)
    return true;

  if (type == 'email')
    obj.email = val;

  if (type == 'cpf' || type == 'cnpj')
    obj.taxIdNumber = val;

  return account.accountExists(obj).then(r => {
    return {
      valid: r
    }
  });
}

function completeNameVal(value) {
  if (!value)
    return true;

  value = value.trim();

  if (value.indexOf(' ') > 0 && value.indexOf(' ') < value.length)
    return true;

  return false;
}

function olderVal(value) {

  if (!value || value.length != 10)
    return true;

  if (!moment(value, "DD-MM-YYYY").isValid())
    return Promise.resolve({ valid: false, data: true });

  return Promise.resolve({ valid: moment(value, "DD-MM-YYYY").add(18, 'y').isSameOrBefore(moment()) });
}

function cepValid(value) {
  if (!value)
    return true;

  return value.replace(/[^0-9]/g, '').length == 8;
}

function passwordValid(value) {
  if (value.length >= 8) {
    const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

    var containsNumber = /\d/.test(value);
    var containsUppercase = /[A-Z]/.test(value);
    var containsSpecialCharacter = format.test(value);

    if (containsSpecialCharacter === true &&
      containsUppercase === true &&
      containsNumber === true) {
      return true;
    }

  }

  return false;
}

export const accountExists = {
  messages: {
    en: (field, args) => {
      if (args[0] == 'email')
        return "Email já cadastrado!";
      return "CPF/CNPJ já cadastrado!";
    },
    'pt-BR': (field, args) => {
      if (args[0] == 'email')
        return "Email já cadastrado!";
      return "CPF/CNPJ já cadastrado!";
    }
  },
  validate(value, args) {
    return validaAccount(value, args);
  }
};

export const completeName = {
  messages: {
    en: (field, args) => {
      return "Digite seu nome completo";
    },
    'pt-BR': (field, args) => {
      return "Digite seu nome completo";
    }
  },
  validate(value, args) {
    return completeNameVal(value, args);
  }
};

export const older = {
  messages: {
    en: (field, args, dateError) => {
      return dateError === true ? 'Data inválida!' : "Somente para maiores de idade";
    },
    'pt-BR': (field, args, dateError) => {
      return dateError === true ? 'Data inválida!' : "Somente para maiores de idade";
    }
  },
  validate(value, args) {
    return olderVal(value, args);
  }
};

export const cep = {
  messages: {
    en: (field, args) => {
      return "CEP inválido (somente números)";
    },
    'pt-BR': (field, args) => {
      return "CEP inválido (somente números)";
    }
  },
  validate(value, args) {
    return cepValid(value, args);
  }
};

export const moveMaisCPF = {
  messages: {
    en: (field, args) => {
      return "Senha inválida";
    },
    'pt-BR': (field, args) => {
      return "Senha inválida";
    }
  },
  validate(value, args) {
    return passwordValid(value, args);
  }
};


// WEBPACK FOOTER //
// ./src/validators/account.js